(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[39597],{

/***/ 94025:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ Lawsuits; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./src/components/bestrounduplawyers/sideEffects/style.module.scss
var style_module = __webpack_require__(79071);
var style_module_default = /*#__PURE__*/__webpack_require__.n(style_module);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./src/components/shared/sideImage/style.module.scss
var sideImage_style_module = __webpack_require__(61372);
var sideImage_style_module_default = /*#__PURE__*/__webpack_require__.n(sideImage_style_module);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(25675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./src/components/shared/scrollToTop/index.tsx
var scrollToTop = __webpack_require__(76105);
;// CONCATENATED MODULE: ./src/components/shared/sideImage/index.tsx





function SideImage({ title , content , image , imageClassName , flip , showScrollButton =true , titleColor ="#000"  }) {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
        className: `${(sideImage_style_module_default()).wrapper}`,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: `py-8 md:py-24 gap-28 items-center justify-between flex flex-col lg:${flip ? "flex-row-reverse" : "flex-row"} gap-7 px-5 `,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: `lg:w-[50%] mx-auto lg:mx-0`,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                            style: {
                                color: titleColor
                            },
                            children: title
                        }),
                        content.map((string, index)=>/*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                children: string
                            }, index)),
                        showScrollButton && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "mt-14 flex justify-center md:justify-start",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(scrollToTop/* default */.Z, {
                                colors: {
                                    bg: titleColor ?? "#be1e20",
                                    text: "white"
                                },
                                className: "rounded",
                                children: "Get My Free Lawsuit Case Review"
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: `${imageClassName} relative  mx-auto lg:mx-0 `,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                        src: image,
                        layout: "fill",
                        alt: "Image"
                    })
                })
            ]
        })
    });
}

;// CONCATENATED MODULE: ./src/components/bestrounduplawyers/sideEffects/index.tsx



function Lawsuits() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (style_module_default()).wrapper,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: (style_module_default()).inner,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(SideImage, {
                    title: "What Are the Health Risks Associated With Exposure to Roundup?",
                    content: [
                        "Roundup has been linked to health risks such as non-Hodgkin's lymphoma, liver and kidney damage, reproductive problems, and endocrine system disruption. The International Agency for Research on Cancer (IARC) has said that glyphosate, its main active ingredient, is likely to cause cancer in humans. It is also toxic to bees and other wildlife, and many countries have limited or banned its use.", 
                    ],
                    image: "/bestrounduplawyers/assets/images/roundup-1.jpg",
                    imageClassName: "md:w-[530px] md:h-[425px] w-[300px] h-[200px] mt-3",
                    titleColor: "#0a6938",
                    showScrollButton: false,
                    flip: true
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(SideImage, {
                    title: "What Is the Roundup Lawsuit?",
                    content: [
                        "The Roundup lawsuit is a group of lawsuits against Monsanto, the company that first made the herbicide Roundup. The lawsuits claim that using Roundup can cause non-Hodgkin's lymphoma and other types of cancer. In these lawsuits, people say that Monsanto didn't warn people enough about the possible health risks of Roundup and that the company hid or changed scientific data to downplay the product's dangers.",
                        "Thousands of individuals have filed lawsuits against Monsanto and its parent company, Bayer AG. The lawsuits have sparked a broader debate about the safety of glyphosate-based herbicides and the role of corporations in protecting public health.", 
                    ],
                    image: "/bestrounduplawyers/assets/images/roundup-2.jpg",
                    imageClassName: "md:w-[530px] md:h-[425px] w-[300px] h-[200px] mt-3",
                    titleColor: "#0a6938",
                    showScrollButton: false
                })
            ]
        })
    });
}


/***/ }),

/***/ 76105:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ ScrollToTop; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);

function ScrollToTop({ children , className , colors  }) {
    const scrollToTop = ()=>{
        window.scroll({
            top: 0,
            left: 0,
            behavior: "smooth"
        });
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
        onClick: ()=>scrollToTop(),
        style: {
            backgroundColor: colors?.bg ?? "black",
            color: colors?.text ?? "grey"
        },
        className: `px-8 py-3 hover:opacity-90 transition-opacity ${className ?? ""}`,
        children: children
    });
}


/***/ }),

/***/ 79071:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"primaryColor":"#16556d","lightPrimaryColor":"#dff5f9","whyUsItemTitle":"#005670","offerCallNumber":"#006336","slogan":"#018484","progressColor":"#1c75bc","linkColorDefault":"#018484","buttonBgColorDefault":"#01847f","whyUsBackgroundColor":"#005c58","whyUsColor":"#fff","melon":"#fe895c","darkSeaGreen":"#0e7d3f","marigold":"#ffcb03","fadedRed":"#cd2f32","dodgerBlue":"#4f85ff","pinkishGrey":"#bfbfbf","sea":"#329eaa","softBlue":"#6b67e9","slightlyBlack":"#161616","tealGreen":"#83b855","greyish":"#b3b3b3","paleGrey":"#f8f9fa","navy":"#011d41","pagePaddingX":"1rem","autumnGlory":"#3ea636","blackLead":"#464c4d","primary":"#b91c45","shiningSilver":"#c8c8c8","bleachedSilk":"#f3f2f2","blackBeauty":"#28252b","battleshipGrey":"#6d7577","winterSolstice":"#47525d","puritanGrey":"#a8aeaf","nero":"#242626","direWolf":"#272828","placeboBlue":"#ebf4fd","chiGong":"#ff1919","mississippiRiver":"#386189","spiroDiscoBall":"#0ac5ff","linkColor":"#565656","gray":"#eaeaea","grayBg":"#fafafa","graydark":"#b3b3b3","grayLight":"#ececec","orange":"#faa931","orangeDark":"#ff700e","orangeLight":"#f1c19c","orangePopup":"#f7951e","Blue":"#5dbbfe","blueDark":"#1b4874","green":"#0a6938","red":"#f85650","redLight":"#fff5f3","cyan":"#37c8e3","blueAster":"#266199","assault":"#184070","lucea":"#79b4e2","distantHorizon":"#f4f9fa","yellow":"#fff9e7","lynxScreenBlue":"#27aae1","singingBlue":"#0375a3","citrusSplash":"#ffc600","youngNight":"#232323","offerBorderColor":"#e4e7eb","defaultButtonColor":"#00b2b8","defaultProgressColor":"#838282","poseidon":"#143a56","vitamin":"#f90","queenOfTheNight":"#275376","trolleyGrey":"#818181","shadowMountain":"#585858","lcPrimary":"#00203f","lcSecondary":"#fdfdfd","lcLightPrimary":"#bf0a2f","lcHover":"#eef7ff","lcLink":"#ff9a03","lcButton":"#bf0a2f","lcProgress":"#9e9d9e","whyUsTitle":"#2e2e2e","whyUsItemBrief":"#747474","headerPhoneColor":"#dd6453","headerCallCenter":"#129188","goGoGreen":"#008a7b","bankVault":"#747474","secondary":"#444b53","progress":"#e489a2","hover":"#b31c1a","blue":"#0d4085","pink":"#f59aac","hoverBg":"#fef8fb","greyLight":"#f3f3f3","darkGreen":"#00a259","greenButton":"#00a259","purple":"#51378e","orangeHover":"#f1dfd0","grey":"#777","darkRed":"#ae332f","stickBtnBgColor":"#f89a1c","stickBtnBorderColor":"#f89a1c","blueLight":"#e9f9ff","carnival":"#ff9800","nickel":"#2f6177","footerColor":"#2f6177","button":"#fff2f1","darkBlue":"#222e59","lightGreen":"#d3e0c9","purpleLight":"#f6f1ff","purpleDark":"#674998","progressBarColor":"#b0b0b0","sloganColor":"#515151","phoneNumberColor":"#0d7166","popupMainColor":"#4d7ea6","stickTitleColor":"#000","stickBtnTxtColor":"#fff","progressbar":"#9a9a9a","mainColor":"#0071ac","whyUs":"#316767","secondaryColor":"#f2f4ea","tepezzaGrey":"#7d7d7d","paragraphColor":"#232323","iconColor":"#e05d26","whyUsBriefColor":"#747474","gorseYellowOrange":"#ff9800","denimBlue":"#2f6177","inner":"style_inner__b_1FB"};

/***/ }),

/***/ 61372:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"primaryColor":"#16556d","lightPrimaryColor":"#dff5f9","whyUsItemTitle":"#005670","offerCallNumber":"#006336","slogan":"#018484","progressColor":"#1c75bc","linkColorDefault":"#018484","buttonBgColorDefault":"#01847f","whyUsBackgroundColor":"#005c58","whyUsColor":"#fff","melon":"#fe895c","darkSeaGreen":"#0e7d3f","marigold":"#ffcb03","fadedRed":"#cd2f32","dodgerBlue":"#4f85ff","pinkishGrey":"#bfbfbf","sea":"#329eaa","softBlue":"#6b67e9","slightlyBlack":"#161616","tealGreen":"#83b855","greyish":"#b3b3b3","paleGrey":"#f8f9fa","navy":"#011d41","pagePaddingX":"1rem","autumnGlory":"#3ea636","blackLead":"#464c4d","primary":"#b91c45","shiningSilver":"#c8c8c8","bleachedSilk":"#f3f2f2","blackBeauty":"#28252b","battleshipGrey":"#6d7577","winterSolstice":"#47525d","puritanGrey":"#a8aeaf","nero":"#242626","direWolf":"#272828","placeboBlue":"#ebf4fd","chiGong":"#ff1919","mississippiRiver":"#386189","spiroDiscoBall":"#0ac5ff","linkColor":"#565656","gray":"#eaeaea","grayBg":"#fafafa","graydark":"#b3b3b3","grayLight":"#ececec","orange":"#faa931","orangeDark":"#ff700e","orangeLight":"#f1c19c","orangePopup":"#f7951e","Blue":"#5dbbfe","blueDark":"#1b4874","green":"#0a6938","red":"#f85650","redLight":"#fff5f3","cyan":"#37c8e3","blueAster":"#266199","assault":"#184070","lucea":"#79b4e2","distantHorizon":"#f4f9fa","yellow":"#fff9e7","lynxScreenBlue":"#27aae1","singingBlue":"#0375a3","citrusSplash":"#ffc600","youngNight":"#232323","offerBorderColor":"#e4e7eb","defaultButtonColor":"#00b2b8","defaultProgressColor":"#838282","poseidon":"#143a56","vitamin":"#f90","queenOfTheNight":"#275376","trolleyGrey":"#818181","shadowMountain":"#585858","lcPrimary":"#00203f","lcSecondary":"#fdfdfd","lcLightPrimary":"#bf0a2f","lcHover":"#eef7ff","lcLink":"#ff9a03","lcButton":"#bf0a2f","lcProgress":"#9e9d9e","whyUsTitle":"#2e2e2e","whyUsItemBrief":"#747474","headerPhoneColor":"#dd6453","headerCallCenter":"#129188","goGoGreen":"#008a7b","bankVault":"#747474","secondary":"#444b53","progress":"#e489a2","hover":"#b31c1a","blue":"#0d4085","pink":"#f59aac","hoverBg":"#fef8fb","greyLight":"#f3f3f3","darkGreen":"#00a259","greenButton":"#00a259","purple":"#51378e","orangeHover":"#f1dfd0","grey":"#777","darkRed":"#ae332f","stickBtnBgColor":"#f89a1c","stickBtnBorderColor":"#f89a1c","blueLight":"#e9f9ff","carnival":"#ff9800","nickel":"#2f6177","footerColor":"#2f6177","button":"#fff2f1","darkBlue":"#222e59","lightGreen":"#d3e0c9","purpleLight":"#f6f1ff","purpleDark":"#674998","progressBarColor":"#b0b0b0","sloganColor":"#515151","phoneNumberColor":"#0d7166","popupMainColor":"#4d7ea6","stickTitleColor":"#000","stickBtnTxtColor":"#fff","progressbar":"#9a9a9a","mainColor":"#0071ac","whyUs":"#316767","secondaryColor":"#f2f4ea","tepezzaGrey":"#7d7d7d","paragraphColor":"#232323","iconColor":"#e05d26","whyUsBriefColor":"#747474","gorseYellowOrange":"#ff9800","denimBlue":"#2f6177","wrapper":"style_wrapper___NhND","wrapperBackground":"style_wrapperBackground__QqvZp"};

/***/ })

}]);